// Methods that are tracked for JRPC requests that are handled internally and not through network fetch
const ANALYTICS_TRACKED_INTERNAL_JPRC_METHODS = {
  // Ethereum methods
  ETH_TRANSACTION: "eth_sendTransaction",
  ETH_SIGN_TRANSACTION: "eth_signTransaction",
  ETH_SIGN: "eth_sign",
  PERSONAL_SIGN: "personal_sign",
  ETH_SIGN_TYPED_DATA_V4: "eth_signTypedData_v4",
  // Solana methods
  SIGN_TRANSACTION: "solana_signTransaction",
  SIGN_ALL_TRANSACTIONS: "solana_signAllTransactions",
  SIGN_MESSAGE: "solana_signMessage"
};

// Methods that are tracked for network fetch requests
const ANALYTICS_TRACKED_NETWORK_JPRC_METHODS = {
  // Ethereum methods
  ETH_SEND_RAW_TRANSACTION: "eth_sendRawTransaction",
  ETH_SEND_USER_OPERATION: "eth_sendUserOperation",
  ETH_SPONSOR_USER_OPERATION: "pm_sponsorUserOperation",
  // Solana methods
  SEND_TRANSACTION: "solana_sendTransaction"
};
const ANALYTICS_EVENTS = {
  JRPC_REQUEST_COMPLETED: "JRPC Request Completed",
  JRPC_REQUEST_FAILED: "JRPC Request Failed"
};
const ANALYTICS_JRPC_REQUEST_TYPES = {
  INTERNAL: "internal",
  NETWORK: "network"
};
const SOLANA_CAIP_CHAIN_MAP = {
  "0x65": "5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
  "0x66": "4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z",
  "0x67": "EtWTRABZaYq6iMfeYKouRu166VU2xqa1"
};

export { ANALYTICS_EVENTS, ANALYTICS_JRPC_REQUEST_TYPES, ANALYTICS_TRACKED_INTERNAL_JPRC_METHODS, ANALYTICS_TRACKED_NETWORK_JPRC_METHODS, SOLANA_CAIP_CHAIN_MAP };
